"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@jobmatchme/ui/es/components/TextField"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _jsxRuntime = require("react/jsx-runtime");

var TextFieldWrapper = function TextFieldWrapper(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      value = _ref.value,
      name = _ref.name,
      icon = _ref.icon,
      onChange = _ref.onChange,
      inputRef = _ref.inputRef,
      inputProps = _ref.inputProps,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$combinedLeft = _ref.combinedLeft,
      combinedLeft = _ref$combinedLeft === void 0 ? false : _ref$combinedLeft,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      _ref$endAdornment = _ref.endAdornment,
      endAdornment = _ref$endAdornment === void 0 ? false : _ref$endAdornment;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
    type: type,
    disabled: disabled,
    disabledBg: disabled,
    value: value,
    name: name,
    placeholder: placeholder,
    onChange: onChange,
    bsSize: "lg",
    fullWidth: true,
    defaultInput: true,
    inputRef: inputRef,
    inputProps: inputProps,
    customSize: "medium",
    combinedLeft: combinedLeft,
    defaultValue: defaultValue,
    endAdornment: endAdornment,
    startAdornment: icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
      position: "start",
      children: icon
    })
  });
};

var _default = TextFieldWrapper;
exports.default = _default;